export const DEFAULT_MODEL = 'mm-01';
